module.exports = __webpack_public_path__ + "assets/GoogleSans-Regular.50adb10be3102e025c72451c7e73b42c.woff2";